import { apiFetch } from "@/lib/api";

const KEY = "readoo_signup_attr";
const MAX_AGE = 30 * 24 * 60 * 60 * 1000;

export function rememberVantaggiVisit(search = "") {
  const q = new URLSearchParams(search);
  const prev = readAttr();
  const utm = ["utm_source", "utm_medium", "utm_campaign"].reduce((o, k) => ({ ...o, [k]: q.get(k) || prev?.[k] || null }), {});
  try { localStorage.setItem(KEY, JSON.stringify({ source: "vantaggi", ...utm, at: Date.now() })); } catch {}
}

function readAttr() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && Date.now() - v.at < MAX_AGE ? v : null;
  } catch { return null; }
}

// Dopo login/registrazione: il backend la salva solo se l'account è appena stato creato.
export function sendSignupAttribution() {
  const v = readAttr();
  if (!v) return;
  try { localStorage.removeItem(KEY); } catch {}
  const { at, ...body } = v;
  apiFetch(`/auth/attribution`, { method: "POST", auth: true, body }).catch(() => {});
}
